// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3rfKF","cell":"ColumnAccessor_cell__2vF_7","firstCellAccent":"ColumnAccessor_firstCellAccent__2YBLL"};